<template>
  <div>
    <div class="Actions__Nav" style="padding-right: 10px">
      <ul>
        <li v-for="action in actions" :key="action.actionId">
          <button
            @click="actionsOnTank"
            :style="{ color: action.color }"
            :data-action-id="action.actionId"
            :disabled="action.disabled"
          >
            <img
              :src="`../../assets/icons/${action.iconName}.svg`"
              alt="icon"
              v-if="action.actionId !== 11 && action.actionId !== 12"
            />
            <img
              :src="`../../assets/icons/${action.iconName}.png`"
              alt="icon"
              v-else
            />
            <span>{{ action.textPrikaz }}</span>
          </button>
        </li>
        <!-- Tri tacke za pranje -->

        <li>
          <v-speed-dial
            v-model="fab"
            direction="bottom"
            :open-on-hover="true"
            transition="slide-y-reverse-transition"
            id="FloatingButton"
          >
            <button
              :key="istakanje.actionId + 1"
              :data-action-id="istakanje.actionId"
              :disabled="istakanje.disabled"
              :style="{ color: istakanje.color }"
              title="Istakanje"
              @click="actionsOnTank"
            >
              <img
                style="background-color: white; width: 100%; height: 100%"
                :src="`../../assets/icons/${istakanje.iconName}.png`"
                alt="icon"
              />
            </button>
            <button
              :key="pranje.actionId + 1"
              :data-action-id="pranje.actionId"
              :disabled="pranje.disabled"
              :style="{ color: pranje.color }"
              title="Pranje"
              @click="actionsOnTank"
            >
              <img
                style="background-color: white; width: 100%; height: 100%"
                :src="`../../assets/icons/${pranje.iconName}.png`"
                alt="icon"
              />
            </button>
          </v-speed-dial>
        </li>
      </ul>

      <div class="Actions__Nav__Select">
        <v-select
          v-model="action_select"
          placeholder="Izaberi akciju"
          class="form-control-select"
          :items="actions2"
          @input="actionsOnTank"
        ></v-select>
      </div>
      <!-- /.Actions__Nav__Select -->
    </div>
    <!-- /.Actions__Nav -->

    <div
      id="Dialog__Overlay"
      class="Dialog__Overlay v-overlay"
      style="z-index: 201"
    ></div>
    <div
      id="Dialog__Content"
      tabindex="-1"
      data-v-fae5bece
      class="Dialog__Content v-dialog__content"
    >
      <div
        id="Dialog"
        class="Dialog v-dialog v-dialog--active"
        v-bind:class="[
          this.action === '7'
            ? 'siri_modal_1200'
            : (this.action === '8' || this.action === '9'
            ? makaClass
            : 'siri_modal'),
        ]"
      >
        <div data-v-fae5bece class="v-card">
          <div
            data-v-fae5bece
            class="v-card__title headline lighten-2 v-card__title--primary"
            style="font-size: 18px !important"
          >
            <!-- Modal Titles  -->

            <div id="naslov" v-if="this.action === '1'">
              {{ $t("actions_nav.entry_of_grapes") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-if="this.action === '10'">
              {{ $t("actions_nav.pressing") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '2'">
              {{ $t("actions_nav.streaming") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '3'">
              {{ $t("actions_nav.coupaging") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '4'">
              {{ $t("actions_nav.filtering") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '11'">
              {{ $t("actions_nav.empting") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '12'">
              {{ $t("actions_nav.washing") }} - {{ this.naziv_tanka }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '5'">
              {{ $t("actions_nav.mixing") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '6'">
              {{ $t("actions_nav.filling") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '7'">
              {{ $t("actions_nav.bottling") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '8'">
              {{ $t("actions_nav.adding") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>
            <div id="naslov" v-else-if="this.action === '9'">
              {{ $t("actions_nav.measurement") }} - {{ this.naziv_tanka }} {{ this.naziv_vina }}
              <v-icon
                v-if="!edit && tank_phase_vine_blendId === 0"
                slot="activator"
                small
                class="ml-2"
                color="teal"
                style="padding-bottom: 4px"
                title="Ovo su istorijski podaci jer se navedeno vino ne nalazi u izabranom tanku."
              >
                info
              </v-icon>
            </div>

            <button
              id="closeModalBtn"
              @click="actionsOnTank"
              class="v-btn v-btn--flat white"
            >
              <v-icon>close</v-icon>
            </button>
          </div>

          <div data-v-fae5bece class="spacer"></div>

          <div v-if="this.action === '1'">
            <GrapeInput @mounted="customMounted" />
          </div>
          <div v-if="this.action === '10'">
            <Pressing @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '2'">
            <Decanting @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '3'">
            <Coupage @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '4'">
            <Filtering @mounted="customMounted" />
          </div>
          <div v-if="this.action === '11'">
            <Empting @mounted="customMounted" />
          </div>
          <div v-if="this.action === '12'">
            <Washing @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '5'">
            <FunctionPouring @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '6'">
            <Filling @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '7'">
            <FunctionPouring @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '8'">
            <Adding @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '9'">
            <Measurement @mounted="customMounted" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { serverBus } from "../../main";

import GrapeInput from "./../GrapeInput";
import Measurement from "./../Measurement";
//import Mixing from "./../Mixing";
import Adding from "./../Adding";
//import Function from "./../Function";
import FunctionPouring from "./../FunctionPouring";
import Filling from "./../Filling";
import Decanting from "./../Decanting";
import Filtering from "./../Filtering";
import Coupage from "./../Coupage";
import Pressing from "./../Pressing";
import Empting from "./../Empting";
import Washing from "./../Washing";


// import {
//   setDocumentDirectionPerLocale,
//   setDocumentTitle,
//   setDocumentLang
// } from "../../util/i18n/document"

const MountedMixin = {
  mounted() {
    //alert(1);
    this.$emit("mounted");

    // this.$watch(
    //   "$i18n.locale",
    //   (newLocale, oldLocale) => {
    //     if (newLocale === oldLocale) {
    //       return
    //     }
    //     setDocumentLang(newLocale)
    //     setDocumentDirectionPerLocale(newLocale)
    //     setDocumentTitle(this.$t("app.title"))
    //   },
    //   { immediate: true }
    // )
  },
};

export default {
  name: "ActionsNav",
  dialog: false,
  data() {
    return {
      makaClass: "dodavanje_flasiranje",
      fab: false,
      action_select: 0,
      action: 0,
      tank_phase_vineId: 0,
      tank_phase_vine_blendId: 0,
      tank_quantity: 0,
      unit_of_measure: "",
      tank_phase: 0,
      tank_phase_mark: "",
      tank_phase_bottling: "",
      tankId: 0,
      tank_name: "",
      wine_type: 0,
      wine_id: 0,
      naziv_tanka: "",
      naziv_vina: "",
      oznaka_faze: "",
      oznaka_faze_flasiranja: "",
      kolicina_vina: 0,
      jedinica_mere: "",
      id_kolicina_jm: "",
      wine_year: "",
      wine_name: "",
      edit: true,
      pranje: {
        actionId: 12,
        text: "Pranje",
        textPrikaz: this.$t("actions_nav.washing"),
        iconName: "pranje",
        disabled: false,
        color: "#018389",
      },
      istakanje: {
        actionId: 11,
        text: "Istakanje",
        textPrikaz: this.$t("actions_nav.empting"),
        iconName: "istakanje",
        disabled: false,
        color: "#018389",
      },

      izabrani_red: null,

      actions: [
        {
          actionId: 1,
          text: "Ulaz grožđa",
          textPrikaz: this.$t("actions_nav.entry_of_grapes"),
          iconName: "ulaz-grozdja",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 10,
          text: "Presovanje",
          textPrikaz: this.$t("actions_nav.pressing"),
          iconName: "presovanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 2,
          text: "Pretakanje",
          textPrikaz: this.$t("actions_nav.streaming"),
          iconName: "pretakanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 3,
          text: "Kupažiranje",
          textPrikaz: this.$t("actions_nav.coupaging"),
          iconName: "pretakanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 4,
          text: "Filtriranje",
          textPrikaz: this.$t("actions_nav.filtering"),
          iconName: "filtriranje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 5,
          text: "Mešanje",
          textPrikaz: this.$t("actions_nav.mixing"),
          iconName: "mesanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 6,
          text: "Dolivanje",
          textPrikaz: this.$t("actions_nav.filling"),
          iconName: "dolivanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 7,
          text: "Flaširanje",
          textPrikaz: this.$t("actions_nav.bottling"),
          iconName: "flasiranje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 8,
          text: "Dodavanje",
          textPrikaz: this.$t("actions_nav.adding"),
          iconName: "dodavanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 9,
          text: "Merenje",
          textPrikaz: this.$t("actions_nav.measurement"),
          iconName: "merenje",
          disabled: false,
          color: "#018389",
        },
      ],
      actions2: [
        {
          actionId: 1,
          text: "Ulaz grožđa",
          textPrikaz: this.$t("actions_nav.entry_of_grapes"),
          iconName: "ulaz-grozdja",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 10,
          text: "Presovanje",
          textPrikaz: this.$t("actions_nav.pressing"),
          iconName: "presovanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 2,
          text: "Pretakanje",
          textPrikaz: this.$t("actions_nav.streaming"),
          iconName: "pretakanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 3,
          text: "Kupažiranje",
          textPrikaz: this.$t("actions_nav.coupaging"),
          iconName: "pretakanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 4,
          text: "Filtriranje",
          textPrikaz: this.$t("actions_nav.filtering"),
          iconName: "filtriranje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 5,
          text: "Mešanje",
          textPrikaz: this.$t("actions_nav.mixing"),
          iconName: "mesanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 6,
          text: "Dolivanje",
          textPrikaz: this.$t("actions_nav.filling"),
          iconName: "dolivanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 7,
          text: "Flaširanje",
          textPrikaz: this.$t("actions_nav.bottling"),
          iconName: "flasiranje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 8,
          text: "Dodavanje",
          textPrikaz: this.$t("actions_nav.adding"),
          iconName: "dodavanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 9,
          text: "Merenje",
          textPrikaz: this.$t("actions_nav.measurement"),
          iconName: "merenje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 11,
          text: "Istakanje",
          textPrikaz: this.$t("actions_nav.empting"),
          iconName: "istakanje",
          disabled: false,
          color: "#018389",
        },
        {
          actionId: 12,
          text: "Pranje",
          textPrikaz: this.$t("actions_nav.washing"),
          iconName: "pranje",
          disabled: false,
          color: "#018389",
        },
      ],
    };
  },
  components: {
    // Mixing: resolve => {
    // 	setTimeout(() => {
    // 		const component = Mixing;
    // 		component.mixins = [];
    // 		component.mixins.push(MountedMixin);
    // 		resolve(component);
    // 	}, 300);
    // },
    GrapeInput: (resolve) => {
      setTimeout(() => {
        const component = GrapeInput;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Measurement: (resolve) => {
      setTimeout(() => {
        const component = Measurement;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Adding: (resolve) => {
      setTimeout(() => {
        const component = Adding;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    FunctionPouring: (resolve) => {
      setTimeout(() => {
        const component = FunctionPouring;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Filling: (resolve) => {
      setTimeout(() => {
        const component = Filling;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Decanting: (resolve) => {
      setTimeout(() => {
        const component = Decanting;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Pressing: (resolve) => {
      setTimeout(() => {
        const component = Pressing;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Filtering: (resolve) => {
      setTimeout(() => {
        const component = Filtering;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Coupage: (resolve) => {
      setTimeout(() => {
        const component = Coupage;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Empting: (resolve) => {
      setTimeout(() => {
        const component = Empting;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Washing: (resolve) => {
      setTimeout(() => {
        const component = Washing;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
  },
  methods: {
    actionsOnTank(e) {
      // alert("actionsOnTank");
      // if (typeof e.path != "undefined")
      // 	// // console.log(e.path[0].id);
      // else
      // {

      // }

      const Dialog__Content = document.getElementById("Dialog__Content"),
        Dialog__Overlay = document.getElementById("Dialog__Overlay"),
        Tank = document.querySelectorAll(".Tank");

      //

      let vueInstance = this;
      let isOpen = false;
      let isTankSelected = false;
      let tankId = 0;

      if (e.target !== undefined) {
        this.action = e.target.dataset.actionId;
      }

      function checkIsTankSelected() {
        if (
          vueInstance.izabrani_red !== undefined &&
          vueInstance.izabrani_red !== null
        ) {
          tankId = vueInstance.izabrani_red.tankId;

          vueInstance.tankId = vueInstance.izabrani_red.tankId;
          vueInstance.naziv_tanka = vueInstance.izabrani_red.tankName;

          isTankSelected = true;
        } else
          for (let i = 0; i < Tank.length; i++) {
            if (Tank[i].classList.contains("active")) {
              tankId = Tank[i].dataset.tankId;
              // tank_phase_vineId = Tank[i].dataset.tankPhaseVineId;

              vueInstance.tank_phase_vineId = Tank[i].dataset.tankPhaseVineId;
              vueInstance.tankId = Tank[i].dataset.tankId;
              vueInstance.tank_type = Tank[i].dataset.tankType;
              vueInstance.tank_quantity = Tank[i].dataset.tankQuantity;
              vueInstance.tank_phase = Tank[i].dataset.tankPhase;
            vueInstance.tank_phase_mark = Tank[i].dataset.tankPhaseMark;
            vueInstance.tank_phase_bottling = Tank[i].dataset.tankPhaseBottling;
              vueInstance.wine_type = Tank[i].dataset.wineType;
              vueInstance.tank_name = Tank[i].dataset.tankName;
              vueInstance.wine_id = Tank[i].dataset.wineId;
              vueInstance.unit_of_measure = Tank[i].dataset.unitOfMeasure;
              vueInstance.id_kolicina_jm = Tank[i].dataset.unitOfMeasureId;
              vueInstance.wine_year = Tank[i].dataset.vineYear;
              vueInstance.wine_name = Tank[i].dataset.vineName;
              vueInstance.tank_type_lable = Tank[i].dataset.tankTypeLable;

              if (typeof Tank[i].dataset.tankEdit !== "undefined")
                if (Tank[i].dataset.tankEdit === "0") vueInstance.edit = false;
                else vueInstance.edit = true;
              else vueInstance.edit = true;

              isTankSelected = true;
            }
          }
      }

      function modalOpen() {
        if (!isOpen) {
          if (e.target !== undefined) {
            vueInstance.$data.actionId = e.target.dataset.actionId;
          }

          Dialog__Content.style.display = "flex";
          Dialog__Content.classList += " v-dialog__content--active";
          Dialog__Overlay.style.display = "block";
          Dialog__Overlay.classList += " v-overlay--active";

          isOpen = true;
        }
      }

      function modalClose() {
        serverBus.$off("otvori_modal");
        serverBus.$off("applied_coupage");
        serverBus.$off("applied_filling");
        serverBus.$off("applied_function");
        serverBus.$off("applied_pouring");
        serverBus.$off("refresh_header");
        serverBus.$off("applied_grape_input");
        serverBus.$off("applied_measurement");
        serverBus.$off("applied_tank");
        serverBus.$off("applied_room");

        serverBus.$off("refresh_tank");
        serverBus.$off("refresh_tank_pom");
        serverBus.$off("refresh_room");

        serverBus.$off("adding");
        serverBus.$off("applied_adding");

        serverBus.$off("refresh_pouring");
        serverBus.$off("refresh_adding");
        serverBus.$off("refresh_grape_input");

        serverBus.$off("applied_decanting");
        serverBus.$off("clear_decanting");
        serverBus.$off("refresh_decanting");
        serverBus.$off("refresh_pressing");

        serverBus.$off("applied_filtering");
        serverBus.$off("clear_filtering");
        serverBus.$off("refresh_filtering");

        serverBus.$off("coupage");
        serverBus.$off("applied_coupage");
        serverBus.$off("refresh_coupage");
        serverBus.$off("applied_coupage_delete");

        serverBus.$off("washing");
        serverBus.$off("applied_washing");
        serverBus.$off("refresh_washing");

        serverBus.$off("decanting");

        Dialog__Content.style.display = "none";
        Dialog__Content.classList.remove("v-dialog__content--active");
        Dialog__Overlay.style.display = "none";
        Dialog__Overlay.classList.remove("v-overlay--active");

        isOpen = false;
        isTankSelected = false;

        vueInstance.tank_phase_vine_blendId = 0;

        for (let i = 0; i < Tank.length; i++) {
          Tank[i].classList.remove("active");
        }

        // alert("maka");
        serverBus.$emit("ucitaj_podatke");
      }

      if (e.target !== undefined) {
        if (e.target.nodeName !== "UL" && e.target.nodeName !== "DIV") {
          checkIsTankSelected();

          /**
           * SingleTank and EmptyTank
           */
          if (Tank.length > 0)
            if (Tank[0].classList[1] === "TankSingle") {
              tankId = Tank[0].dataset.tankId;
              // tank_phase_vineId = Tank[i].dataset.tankPhaseVineId;

              vueInstance.tank_phase_vineId = Tank[0].dataset.tankPhaseVineId;
              vueInstance.tankId = Tank[0].dataset.tankId;
              vueInstance.tank_type = Tank[0].dataset.tankType;
              vueInstance.tank_quantity = Tank[0].dataset.tankQuantity;
              vueInstance.tank_phase = Tank[0].dataset.tankPhase;
            vueInstance.tank_phase_mark = Tank[0].dataset.tankPhaseMark;
            vueInstance.tank_phase_bottling = Tank[0].dataset.tankPhaseBottling;
              vueInstance.wine_type = Tank[0].dataset.wineType;
              vueInstance.tank_name = Tank[0].dataset.tankName;
              vueInstance.wine_id = Tank[0].dataset.wineId;
              vueInstance.unit_of_measure = Tank[0].dataset.unitOfMeasure;
              vueInstance.id_kolicina_jm = Tank[0].dataset.unitOfMeasureId;
              vueInstance.wine_year = Tank[0].dataset.vineYear;
              vueInstance.wine_name = Tank[0].dataset.vineName;
              vueInstance.tank_type_lable = Tank[0].dataset.tankTypeLable;

              if (typeof Tank[0].dataset.tankEdit !== "undefined")
                if (Tank[0].dataset.tankEdit === "0") vueInstance.edit = false;
                else vueInstance.edit = true;
              else vueInstance.edit = true;

              isTankSelected = true;
            }

          this.naziv_tanka = vueInstance.tank_name;

          this.oznaka_faze = vueInstance.tank_phase_mark.replace("0", "-");
          this.oznaka_faze_flasiranja = vueInstance.tank_phase_bottling;
          this.kolicina_vina = vueInstance.tank_quantity;
          this.jedinica_mere = vueInstance.unit_of_measure;

          if (typeof vueInstance.wine_name !== "undefined")
            this.naziv_vina = "/ " + vueInstance.wine_name + (vueInstance.wine_year !== undefined ? " " + vueInstance.wine_year : "");
          // + ' ' + vueInstance.wine_year;
          else this.naziv_vina = "";
        }

        /**
         * Close Modal
         */
        if (e.target.id === "closeModalBtn") {
          modalClose();

          this.izabrani_red = null;

          this.action_select = "undefined";
        } else {
          /**
           * Open Modal
           */

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }
      } else {
        checkIsTankSelected();

        if (Tank.length > 0)
          if (Tank[0].classList[1] === "TankSingle") {
            tankId = Tank[0].dataset.tankId;
            // tank_phase_vineId = Tank[i].dataset.tankPhaseVineId;

            vueInstance.tank_phase_vineId = Tank[0].dataset.tankPhaseVineId;
            vueInstance.tankId = Tank[0].dataset.tankId;
            vueInstance.tank_type = Tank[0].dataset.tankType;
            vueInstance.tank_quantity = Tank[0].dataset.tankQuantity;
            vueInstance.tank_phase = Tank[0].dataset.tankPhase;
            vueInstance.tank_phase_mark = Tank[0].dataset.tankPhaseMark;
            vueInstance.tank_phase_bottling = Tank[0].dataset.tankPhaseBottling;
            vueInstance.wine_type = Tank[0].dataset.wineType;
            vueInstance.tank_name = Tank[0].dataset.tankName;
            vueInstance.wine_id = Tank[0].dataset.wineId;
            vueInstance.unit_of_measure = Tank[0].dataset.unitOfMeasure;
            vueInstance.id_kolicina_jm = Tank[0].dataset.unitOfMeasureId;
            vueInstance.wine_year = Tank[0].dataset.vineYear;
            vueInstance.wine_name = Tank[0].dataset.vineName;
            vueInstance.tank_type_lable = Tank[0].dataset.tankTypeLable;

            if (typeof Tank[0].dataset.tankEdit !== "undefined")
              if (Tank[0].dataset.tankEdit === "0") vueInstance.edit = false;
              else vueInstance.edit = true;
            else vueInstance.edit = true;

            isTankSelected = true;
          }

        // // console.log(Tank[0].dataset);

        this.naziv_tanka = vueInstance.tank_name;
        this.oznaka_faze = vueInstance.tank_phase_mark.replace("0", "-");
          this.oznaka_faze_flasiranja = vueInstance.tank_phase_bottling;
        this.kolicina_vina = vueInstance.tank_quantity;
        this.jedinica_mere = vueInstance.unit_of_measure;

        if (typeof vueInstance.wine_name !== "undefined")
          this.naziv_vina = "/ " + vueInstance.wine_name + (vueInstance.wine_year !== undefined ? " " + vueInstance.wine_year : "") ;
        // + ' ' + vueInstance.wine_year;
        else this.naziv_vina = "";

        if (e === "Ulaz grožđa") {
          if (!this.disable) {
            vueInstance.action = "1";
            vueInstance.$data.actionId = 1;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali tank");
            }
          } else
            alert(
              "Tank nije u fazi alkoholne fermentacije, nije moguće uneti grožđe."
            );
        }

        if (e === "Pretakanje") {
          vueInstance.action = "2";
          vueInstance.$data.actionId = 2;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Presovanje") {
          vueInstance.action = "10";
          vueInstance.$data.actionId = 10;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Kupažiranje") {
          vueInstance.action = "3";
          vueInstance.$data.actionId = 3;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Filtriranje") {
          vueInstance.action = "4";
          vueInstance.$data.actionId = 4;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Mešanje") {
          vueInstance.action = "5";
          vueInstance.$data.actionId = 5;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Dolivanje") {
          vueInstance.action = "6";
          vueInstance.$data.actionId = 6;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Flaširanje") {
          vueInstance.action = "7";
          vueInstance.$data.actionId = 7;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Dodavanje") {
          vueInstance.action = "8";
          vueInstance.$data.actionId = 8;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Merenje") {
          vueInstance.action = "9";
          vueInstance.$data.actionId = 9;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Istakanje") {
          vueInstance.action = "11";
          vueInstance.$data.actionId = 11;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }

        if (e === "Pranje") {
          vueInstance.action = "12";
          vueInstance.$data.actionId = 12;

          if (isTankSelected) {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali tank");
          }
        }
      }

      return tankId;
    },
    customMounted() {
      // alert(this.edit);
      if (this.action == 1) {
        serverBus.$emit(
          "grape_input",
          this.tank_phase_vineId,
          this.tankId,
          this.wine_id,
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tank_phase,
          this.wine_type,
          this.edit,
          this.tank_type_lable,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 2) {
        //
        //alert(this.tank_phase_vine_blendId);

        serverBus.$emit(
          "decanting",
          this.tank_phase_vineId,
          this.tankId,
          this.tank_quantity,
          this.tank_phase,
          this.wine_type,
          this.wine_id,
          this.action,
          this.id_kolicina_jm,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tank_type_lable,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 10) {
        //

        serverBus.$emit(
          "pressing",
          this.tank_phase_vineId,
          this.tankId,
          this.tank_quantity,
          this.tank_phase,
          this.wine_type,
          this.wine_id,
          this.action,
          this.id_kolicina_jm,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tank_type_lable,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 3) {
        serverBus.$emit(
          "coupage",
          this.tank_phase_vineId,
          this.tankId,
          this.tank_quantity,
          this.tank_phase,
          this.wine_type,
          this.wine_id,
          this.action,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tank_type_lable,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 4) {
        //serverBus.$emit("function", this.tank_phase_vineId, "FILTERING");
        serverBus.$emit(
          "filtering",
          this.tank_phase_vineId,
          this.tankId,
          this.tank_quantity,
          this.tank_phase,
          this.wine_type,
          this.wine_id,
          this.action,
          this.id_kolicina_jm,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tank_type_lable,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 5) {
        //serverBus.$emit("mixing", this.tank_phase_vineId, "MIXING");
        serverBus.$emit(
          "pouring",
          this.tank_phase_vineId,
          "MIXING",
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.edit,
          this.wine_type,
          this.wine_id,
          this.tank_type_lable,
          this.tankId,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 6) {
        //

        serverBus.$emit(
          "filling",
          this.tank_phase_vineId,
          this.tankId,
          this.tank_quantity,
          this.tank_phase,
          this.wine_type,
          this.wine_id,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tank_type_lable,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 7) {
        serverBus.$emit(
          "pouring",
          this.tank_phase_vineId,
          "BOTTLING",
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.edit,
          this.wine_type,
          this.wine_id,
          this.tank_type_lable,
          this.tankId,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 8) {
        serverBus.$emit(
          "adding",
          this.tank_phase_vineId,
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tankId,
          this.tank_type,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 9) {
        serverBus.$emit(
          "measurement",
          this.tank_phase_vineId,
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tankId,
          this.tank_type,
          this.edit,
          this.tank_phase_vine_blendId,
          this.oznaka_faze_flasiranja
        );
      } else if (this.action == 11) {
        serverBus.$emit(
          "empting",
          this.tank_phase_vineId,
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tankId,
          this.tank_type,
          this.edit,
          this.tank_phase_vine_blendId
        );
      } else if (this.action == 12) {
        serverBus.$emit(
          "washing",
          this.tank_phase_vineId,
          this.tank_quantity,
          this.oznaka_faze,
          this.jedinica_mere,
          this.tankId,
          this.tank_type,
          this.edit,
          this.tank_phase_vine_blendId
        );
      }
    },
  },
  mounted() {
    
    serverBus.$off("open_modal_prerada");
    serverBus.$on("open_modal_prerada", (akcija, e, item) => {
      this.izabrani_red = item;
      this.tank_name = item.tankName;
      this.wine_name = item.wineAtMoment;
      this.edit = false;

      if (akcija === 2 || akcija === 4 || akcija === 10)
        this.tank_phase_vineId = item.previousTankPhaseWineId;
      else this.tank_phase_vineId = item.tankPhaseWineId;

      if (akcija === 11) this.tank_phase_vine_blendId = item.tankPhaseWineId;
      else this.tank_phase_vine_blendId = item.tankPhaseWineBlendId;

      this.tankId = item.tankId;

      //////// Izmeni kad Kiko doda ////////
      this.tank_type_lable = item.typeLabel;
      //////////////////////////////////////

      this.tank_phase_mark = item.phaseAtMoment;

      this.actionId = akcija;
      this.action = akcija;

      this.actionsOnTank(e);
    });

    serverBus.$off("disable_action");

    serverBus.$on("disable_action", (nizVred) => {
      // alert(disable);
      //this.pom_disable = disable;

      let i = 0;

      while (i < nizVred.length - 2) {
        this.actions[i].disabled = nizVred[i];

        if (nizVred[i]) {
          this.actions[i].iconName =
            this.actions[i].iconName.replace("-grey", "") + "-grey";
          this.actions[i].color = "#c3c3c3";
        } else {
          this.actions[i].iconName = this.actions[i].iconName.replace(
            "-grey",
            ""
          );
          this.actions[i].color = "#018389";
        }

        this.actions2[i].disabled = nizVred[i];

        if (nizVred[i]) {
          this.actions2[i].iconName =
            this.actions2[i].iconName.replace("-grey", "") + "-grey";
          this.actions2[i].color = "#c3c3c3";
        } else {
          this.actions2[i].iconName = this.actions2[i].iconName.replace(
            "-grey",
            ""
          );
          this.actions2[i].color = "#018389";
        }

        i++;
      }

      this.istakanje.disabled = nizVred[i];

      

      if (nizVred[i]) {
        this.istakanje.iconName =
          this.istakanje.iconName.replace("-grey", "") + "-grey";
        this.istakanje.color = "#c3c3c3";
      } else {
        this.istakanje.iconName = this.istakanje.iconName.replace("-grey", "");
        this.istakanje.color = "#018389";
      }

      this.actions2[i].disabled = nizVred[i];

      if (nizVred[i]) {
        this.actions2[i].iconName =
          this.actions2[i].iconName.replace("-grey", "") + "-grey";
        this.actions2[i].color = "#c3c3c3";
      } else {
        this.actions2[i].iconName = this.actions2[i].iconName.replace(
          "-grey",
          ""
        );
        this.actions2[i].color = "#018389";
      }

      this.pranje.disabled = nizVred[i+1];

      

      if (nizVred[i+1]) {
        this.pranje.iconName =
          this.pranje.iconName.replace("-grey", "") + "-grey";
        this.pranje.color = "#c3c3c3";
      } else {
        this.pranje.iconName = this.pranje.iconName.replace("-grey", "");
        this.pranje.color = "#018389";
      }

      this.actions2[i+1].disabled = nizVred[i+1];

      if (nizVred[i+1]) {
        this.actions2[i+1].iconName =
          this.actions2[i+1].iconName.replace("-grey", "") + "-grey";
        this.actions2[i+1].color = "#c3c3c3";
      } else {
        this.actions2[i+1].iconName = this.actions2[i+1].iconName.replace(
          "-grey",
          ""
        );
        this.actions2[i+1].color = "#018389";
      }
    });
  },
  //}
};
</script>
<style scoped lang='scss'>
@import "./../parts/../../assets/sass/parts/modalStyles_siri_modal";

.Actions__Nav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;
  left: $closedNavWidth;
  padding: 10px 130px 10px 60px;
  background-color: rgb(247, 247, 247);
  @media (max-width: 1200px) {
    height: 71px;
    padding-top: 10px;
    padding-right: 55px;
  }
  ul {
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    list-style-type: none;
    justify-content: space-between;
    padding-left: 0;
    @media (max-width: 1200px) {
      display: none;
    }
    button {
      // color: #018389;
      font-weight: 300;
      letter-spacing: 0;
      text-decoration: none;
      text-transform: uppercase;

      font-family: "NunitoSans", sans-serif;
      // &:focus {
      //   outline: 1px solid #018389;
      // }
      > * {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        pointer-events: none;
      }
      img {
        margin-right: 7px;
        width: 37px;
        height: 37px;
      }
    }

    button:hover {
      transform: scale(1.2);
      transition: all 0.4s ease-in-out;
    }
  }
  &__Select {
    display: none;
    @media (max-width: 1200px) {
      display: block;
      width: 200px;
      float: right;
    }
  }
}

// .maka {
//         max-width: 1000px !important;
//       }

#FloatingButton {
  background-image: url("../../assets/icons/tri_tacke.png");
  background-position: center;
  bottom: 0px;
  width: 40px;
  height: 40px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  //background-color: #018389;
  background-color: #f7f7f7;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;

  @media (max-width: 1200px) {
    height: 71px;
    padding-top: 10px;
    padding-right: 55px;
  }
  p {
    position: relative;
    width: 100%;
    height: 100%;
    i {
      position: absolute;
      left: 15px;
      top: 15px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
</style>